/**
 * Clamps input number between the max and min values
 * @param {number} num input value
 * @param {number} max value allowed
 * @param {number} [min=0] value allowed
 * @returns {number} between max and min
 */
export const clampNumber = (
  num: number,
  max: number,
  min: number = 0,
): number => Math.min(Math.max(num, min), max);
